import ChartsService from '@/services/benchmarks/ChartsService';
import { getBenchmarkId, SERIES_BY_MEDIA, chartLegendOrder } from '@/utils';

import { chartsMutationTypes } from '../mutation-types';

export async function fetchSentimentsInTheCommentsOverTime({ commit, rootState, rootGetters, state }, { datePortion, groupSelected }) {
  try {
    commit(chartsMutationTypes.SENTIMENTS_IN_THE_COMMENTS_OVER_TIME_LOADING, true);
    commit(chartsMutationTypes.SENTIMENTS_IN_THE_COMMENTS_OVER_TIME_ERROR, false);

    const periodLabel = rootGetters['ui/getSentimentsInTheCommentsOverTimePeriod'].label;
    const period = datePortion ?? periodLabel;
    const channelSelected = rootState.ui.channel;

    const hasGroupInGroupList = rootState.ui.groupList.find(group => group.id === state.sentimentsInTheCommentsOverTime.groupSelected)?.id;
    const defaultGroupId = groupSelected || hasGroupInGroupList || rootState.ui.groupList[0].id;

    const { data } = await ChartsService.getSentimentsInTheCommentsOverTime({
      'benchmark-id': getBenchmarkId(),
      'group-id': defaultGroupId,
      'start-date': rootState.ui.dateRange.start,
      'end-date': rootState.ui.dateRange.end,
      channel: rootState.ui.channel,
      'date-portion': period,
    });

    if (!Array.isArray(data)) throw new Error();

    const sentimentsTypes = {
      positive: 'Positivo',
      negative: 'Negativo',
      neutral: 'Neutro',
      'not_classified': 'Não classificado',
    };

    const serie = data.map((index) => {
      const sentiment = sentimentsTypes[index.polarities.toLowerCase()];
      return {
        data: index.data,
        fillOpacity: 0,
        lineWidth: 3,
        name: sentiment,
        index: chartLegendOrder.sentimentsInTheCommentsOverTime[sentiment.toLowerCase()],
        color: channelSelected === 'Todas'
          ? SERIES_BY_MEDIA.all[sentiment.toLowerCase()]?.color
          : SERIES_BY_MEDIA[channelSelected.toLowerCase()][sentiment.toLowerCase()]?.color,
      };
    });

    commit(chartsMutationTypes.SENTIMENTS_IN_THE_COMMENTS_OVER_TIME_DATA, { data: serie });
  } catch (e) {
    commit(chartsMutationTypes.SENTIMENTS_IN_THE_COMMENTS_OVER_TIME_ERROR, true);
    console.error(e);
    return e;
  } finally {
    commit(chartsMutationTypes.SENTIMENTS_IN_THE_COMMENTS_OVER_TIME_LOADING, false);
  }
}
